import { commonRequest } from "../../../services/ApiCall";
import { Helpers } from "../../../services/Helpers";

export const NotificationServices = {
    sendNotification : async (data)=>{
        // return await commonRequest("POST", `${Helpers.URL()}/api/notification/send-custom-notification`,data, Helpers.token());
        return await commonRequest("POST", `${Helpers.URL()}/api/v2/admin/notification/send-custom-notification`,data, Helpers.token());
    },
    fetchNotification: async (data) => {
        console.log("filter Data",data);
        const queryParams = new URLSearchParams();

        // Basic pagination and sorting parameters
        queryParams.append('page', data.page + 1);
        queryParams.append('limit', data.limit);

        // Search parameters
        queryParams.append('searchKey', data.filters.searchKey || '');
        

        // Sorting parameters
        if (data.filters.sortKey) {
            queryParams.append('sortKey', data.filters.sortKey);            
            queryParams.append('sortDirection', data.filters.sortDirection || 'desc');
        }
        
        // // Active or not filters
        // queryParams.append('isActive', data.filters?.isActive || '');

        // Additional multi-column filters
        if (data.filters.filterOptions) {
            data.filters.filterOptions.forEach((filter, index) => {
                if (filter.fieldName && filter.value) {
                    queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                    queryParams.append(`filters[${index}][operator]`, filter.operator);
                    queryParams.append(`filters[${index}][value]`, filter.value);
                    
                    if (index !== 0) {
                        queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                    }
                    
                    if (filter.operator === 'between') {
                        queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
                    }
                }
            });
        }
        console.log("queryParams",queryParams.toString());
        return await commonRequest("GET",  `${Helpers.URL()}/api/v2/admin/notification/fetchcampaign/list?${queryParams.toString()}`,{}, Helpers.token());
        // return await commonRequest("GET",  `${Helpers.URL()}/api/notification/fetch-custom-notification?${queryParams.toString()}`,{}, Helpers.token());
        // return await commonRequest("POST", `${Helpers.URL()}/api/notification/fetch-custom-notification`,data, Helpers.token());
    },
    fetchAllFilteredCustomers: async(data) => {
        return await commonRequest("POST", `${Helpers.URL()}/api/v2/admin/customer/all/filtered/list`,data, Helpers.token());
    },
    fetchAllFilteredExperts: async(data) => {
        return await commonRequest("POST", `${Helpers.URL()}/api/v2/admin/experts/all/filtered/list`,data, Helpers.token());
    },
    cancelCampaign: async (campaignId) => {
        return await commonRequest("GET", `${Helpers.URL()}/api/v2/admin/notification/cancel-campaign/${campaignId}`, {}, Helpers.token());
    },
    fetchCampaignData: async (campaignId) => {
        return await commonRequest("GET", `${Helpers.URL()}/api/v2/admin/notification/fetch-campaign/${campaignId}`, {}, Helpers.token());
    },
    fetchCustomersAddress: async () => {
        return await commonRequest("GET", `${Helpers.URL()}/api/v2/admin/customer/addressList`, {}, Helpers.token());
    },
    fetchExpertsAddress: async () => {
        return await commonRequest("GET", `${Helpers.URL()}/api/v2/admin/experts/addressList`, {}, Helpers.token());
    },
    fetchCampaignMessages: async (data) => {
        return await commonRequest("POST", `${Helpers.URL()}/api/v2/admin/notification/fetch-messages-details`, data, Helpers.token());
    },
}